<template>
  <div id="side-navi">
    <template>
      <div>
        <b-button
          v-b-toggle.main_menu
          class="menu_btn btn btn-menu d-none"
        >
          <i class="fas fa-angle-right"></i>
        </b-button>

        <b-sidebar
          id="main_menu"
          aria-labelledby="sidebar-no-header-title"
          shadow
          no-header
          backdrop
          variant="primary"
          backdrop-variant="dark"
          class="nav_font_size"
          width="280px"
        >
          <template #default="{ hide }">
            <div id="menu_wrapper" class="">
              <div class="menu_header">
                <div class="row m-0 pt-2">
                  <h4 id="sidebar-no-header-title" class="col-10 text-right">
                    <img :src="logo" class="logo_menu mr-2" alt="iAMc" />
                  </h4>
                  <div class="col-1 pointer" @click="hide()">
                    <i class="fas fa-times"></i>
                  </div>
                </div>
              </div>

              <b-nav vertical>

                <!-- Home -->
                <b-nav-item class="ff">
                  <a href="/dashboard" class="pl-3 menu_dd" @click.prevent="gotoLink('/dashboard', '_self')">
                    <span class="pr-2"><i class="fas fa-home"/></span> Home
                  </a>
                </b-nav-item>

                <!-- Contractions -->
                <b-nav-item class="ff">
                  <a href="/contractions" class="pl-3 menu_dd" @click.prevent="gotoLink('/contractions', '_self')">
                    <span class="pr-2"><i class="fas fa-heart"/></span> Contractions
                  </a>
                </b-nav-item>

                <!-- Meditation -->
                <b-nav-item class="ff">
                  <a href="/meditation_dashboard" class="pl-3 menu_dd" @click.prevent="gotoLink('/meditation_dashboard', '_self')">
                    <span class="pr-2"><i class="fas fa-atom"/></span> Meditation
                  </a>
                </b-nav-item>

                <!-- Community -->
                <b-nav-item class="ff">
                  <a href="/community" class="pl-3 menu_dd" @click.prevent="gotoLink('/community', '_self')">
                    <span class="pr-2"><i class="fas fa-globe"/></span> Community
                  </a>
                </b-nav-item>

                <!-- Connections -->
                <b-nav-item class="ff">
                  <a href="/connections" class="pl-3 menu_dd" @click.prevent="gotoLink('/connections', '_self')">
                    <span class="pr-2"><i class="fas fa-users"/></span> My Connections
                  </a>
                </b-nav-item>

                <!-- Messages -->
                <b-nav-item class="ff">
                  <a href="/chatbox" class="pl-3 menu_dd" @click.prevent="gotoLink('/chatbox', '_self')">
                    <span class="pr-2"><i class="fas fa-comment-dots"/></span> Messages
                  </a>
                </b-nav-item>

                <!-- Support -->
                <b-nav-item class="ff">
                  <a href="/coaches_dashboard" class="pl-3 menu_dd" @click.prevent="gotoLink('/coaches_dashboard', '_self')">
                    <span class="pr-2"><i class="fas fa-life-ring"/></span> Support
                  </a>
                </b-nav-item>

                <!-- Programs -->
                <b-nav-item class="ff">
                  <a href="/programs" class="pl-3 menu_dd" @click.prevent="gotoLink('/programs', '_self')">
                    <span class="pr-2"><i class="fas fa-graduation-cap"/></span> Programs
                  </a>
                </b-nav-item>

                <!-- Daily Log -->
                <b-nav-item class="ff">
                  <a :href="'/reflections/'" class="pl-3 menu_dd" @click.prevent="gotoLink('/reflections/' + $store.state.profile.id, '_self')">
                    <span class="pr-2"><i class="fas fa-book-open"/></span> Reflections
                  </a>
                </b-nav-item>

                <!-- Dreams Log -->
                <b-nav-item class="ff">
                  <a :href="'/dreams_log/' + $store.state.profile.id" class="pl-3 menu_dd" @click.prevent="gotoLink('/dreams_log/' + $store.state.profile.id, '_self')">
                    <span class="pr-2"><i class="fas fa-moon"/></span> Dreams Log
                  </a>
                </b-nav-item>

                <!-- Sleep & Recovery -->
                <b-nav-item class="ff">
                  <a href="/sleep_dashboard" class="pl-3 menu_dd" @click.prevent="gotoLink('/sleep_dashboard', '_self')">
                    <span class="pr-2"><i class="fas fa-bed"/></span> Sleep &amp; Recovery
                  </a>
                </b-nav-item>

                <!-- Statistic Report -->
                <b-nav-item class="ff">
                  <a :href="'/profile_report/' + $store.state.profile.id" class="pl-3 menu_dd" @click.prevent="gotoLink('/profile_report/' + $store.state.profile.id, '_self')">
                    <span class="pr-2"><i class="fas fa-chart-bar"/></span> Statistic Report
                  </a>
                </b-nav-item>

                <!-- Forum -->
                <b-nav-item class="ff">
                  <a href="/forum/dashboard" class="pl-3 menu_dd" @click.prevent="gotoLink('/forum/dashboard', '_self')">
                    <span class="pr-2"><i class="far fa-comments"/></span> Forum
                  </a>
                </b-nav-item>

                <!-- Admin Menu (level >= 90) -->
                <b-nav-item v-if="$store.state.profile.level >= 90" class="ff ff--dropdown">
                  <b class="pl-3 d-block">
                    <span class="pr-2"><i class="fas fa-cog"/></span> Admin Menu
                  </b>
                  <a href="/reports_overview" class="menu_dd menu_dd_sub" @click.prevent="gotoLink('/reports_overview', '_self')">
                    <span class="pr-2"><i class="fas fa-chart-line"/></span> Reports Overview
                  </a>
                  <a href="/members" class="menu_dd menu_dd_sub" @click.prevent="gotoLink('/members', '_self')">
                    <span class="pr-2"><i class="fas fa-user-friends"/></span> Members
                  </a>
                  <a href="/business_teams" class="menu_dd menu_dd_sub" @click.prevent="gotoLink('/business_teams', '_self')">
                    <span class="pr-2"><i class="fas fa-building"/></span> Business Teams
                  </a>
                  <a href="/email_members" class="menu_dd menu_dd_sub" @click.prevent="gotoLink('/email_members', '_self')">
                    <span class="pr-2"><i class="fas fa-envelope"/></span> Email Members
                  </a>
                  <a href="/courses_admin" class="menu_dd menu_dd_sub" @click.prevent="gotoLink('/courses_admin', '_self')">
                    <span class="pr-2"><i class="fas fa-edit"/></span> Courses
                  </a>
                  <a href="/faq_admin" class="menu_dd menu_dd_sub" @click.prevent="gotoLink('/faq_admin', '_self')">
                    <span class="pr-2"><i class="fas fa-question-circle"/></span> FAQ
                  </a>
                  <a href="/board_meditation" class="menu_dd menu_dd_sub" @click.prevent="gotoLink('/board_meditation', '_blank')">
                    <span class="pr-2"><i class="fas fa-atom"/></span> Meditation Board
                  </a>
                  <a href="/board_sleep" class="menu_dd menu_dd_sub" @click.prevent="gotoLink('/board_sleep', '_blank')">
                    <span class="pr-2"><i class="fas fa-bed"/></span> Sleep Board
                  </a>
                  <!-- Super admin only (level 99) -->
                  <template v-if="$store.state.profile.level == 99">
                    <a href="/cards_admin" class="menu_dd menu_dd_sub" @click.prevent="gotoLink('/cards_admin', '_self')">
                      <span class="pr-2"><i class="fas fa-layer-group"/></span> Cards
                    </a>
                    <a href="/sandpit" class="menu_dd menu_dd_sub" @click.prevent="gotoLink('/sandpit', '_self')">
                      <span class="pr-2"><i class="fas fa-umbrella-beach"/></span> Sandpit
                    </a>
                    <a :href="'/databaseDL/' + $store.state.profile.session_id" class="menu_dd menu_dd_sub" @click.prevent="gotoLink('/databaseDL/' + $store.state.profile.session_id, '_blank')">
                      <span class="pr-2"><i class="fas fa-download"/></span> Database DL
                    </a>
                  </template>
                </b-nav-item>

                <b-nav-item>
                  <div class="d-md-none" v-if="deferredPwaPrompt">
                    <button class="btn pl-3 ml-0 text-white install-pwa-button" @click="installPWA()">
                      <i class="fas fa-external-link-alt"></i>
                      Add to homescreen
                    </button>
                  </div>
                </b-nav-item>
              </b-nav>
              <footer class="row text-center safari_only" id="menu_footer">
                <div class="col">
                  <div v-if="logged_in === 0">
                    <b-nav-item>
                      <router-link to="/login">Login <i class="fas fa-sign-in-alt"></i
                      ></router-link>
                    </b-nav-item>
                  </div>
                  <div v-else @click="logOut()" class="btn btn-text gold">
                    <small
                      ><i class="fas fa-sign-out-alt fa-2x"></i> <br />Sign Out
                    </small>
                  </div>
                </div>
                <div class="col">
                  <div v-if="logged_in === 0"></div>
                  <div v-else>
                    <div class="">
                      <a :href="profile_link" class="">
                        <div class="btn btn-text gold text-center">
                          <i class="far fa-user-circle fa-2x"></i>
                          <br /><small v-text="profile_name"></small>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </footer>
            </div>
            <router-link to="/faq" class="d-flex justify-content-center px-2 my-3 text-decoration-none">
              <b-button class="w-100">
                <i class="fas fa-question-circle"></i> Help
              </b-button>
            </router-link>
          </template>
        </b-sidebar>
      </div>
    </template>

    <!-- Bell icon button -->
    <div class="notif-btn-wrap" v-if="logged_in">
      <button class="btn btn-notif-bell" @click="openTray">
        <i class="fas fa-bell"></i>
        <span v-if="unreadNotificationsCount > 0" class="notif-badge">
          {{ unreadNotificationsCount }}
        </span>
      </button>
    </div>

    <!-- Notification tray -->
    <notification-tray v-if="trayOpen" :open="trayOpen" @close="trayOpen = false" />

    <!-- Loading Percentage Display -->
    <progress-bar
      v-if="loading_page_percentage < 1"
      :percentage="loading_page_percentage"
    />
  </div>
</template>

<script>
import ProgressBar from "../components/ProgressBar.vue";
import NotificationTray from "@/components/NotificationTray.vue";
import * as Cookie from "@/assets/js/cookie.js";
import axios from "@/axios";

export default {
  name: "SideNavi",
  components: {
    ProgressBar,
    NotificationTray,
  },
  props: {
    profile_name: {
      type: String,
    },
  },
  data() {
    return {
      logo: this.$store.state.layout.logo,
      profile_link: "/profile",
      session_id: this.$store.state.session_id,
      deferredPwaPrompt: null,
      trayOpen: false,
      unreadNotificationsCount: 0
    };
  },
  computed: {
    loading_page_percentage() {
      let percentage = this.$store.getters.loadingStatus;

      if (isNaN(percentage)) {
        percentage = 0;
      }

      return percentage;
    },
    logged_in() {
      return this.$store.getters.isLoggedIn;
    },
    show_menu() {
      var val = 1;
      if (this.$route.name === "login") {
        val = 0;
      }
      return val;
    },
  },
  methods: {
    logOut() {
      let vars = {
        profile: {
          status: 0,
        },
      };
      this.$store.commit("profileSet", vars);
      this.$store.commit("menuSet", { menu: { items: null } });

      let cookies = document.cookie.split(";");

      for (var i = 0; i < cookies.length; i++) {
        Cookie.deleteCookie(
          cookies[i].split("=")[0],
          process.env.VUE_APP_DOMAIN
        );
      }
      axios({url: 'logout'})
          .then(() => {
            console.log("Logout completed");
            this.$router.push('/login');
          })
          .catch(error => {
            console.error("Logout failed", error);
          });
    },
    async installPWA() {
      if (this.deferredPwaPrompt) {
        this.deferredPwaPrompt.prompt();
        const { outcome } = await this.deferredPwaPrompt.userChoice;
        if (outcome === 'accepted') {
          console.log('User accepted the PWA installation');
        } else {
          console.log('User dismissed the PWA installation');
        }
        this.deferredPwaPrompt = null
      }
    },
    gotoLink(link, target) {
      window.open(link, target)
    },
    openTray() {
      this.trayOpen = !this.trayOpen;
      if (this.trayOpen) {
        this.unreadNotificationsCount = 0;
        sessionStorage.setItem('unreadNotificationsCount', 0);
      }
    },
    getUnreadNotificationsCount() {
      axios('notifications/unread-count')
        .then((response) => {
          this.unreadNotificationsCount = response.data
          sessionStorage.setItem('unreadNotificationsCount', this.unreadNotificationsCount)
        })
    }
  },
  created() {
    this.unreadNotificationsCount = sessionStorage.getItem('unreadNotificationsCount')
    this._notifTimeout = setTimeout(() => this.getUnreadNotificationsCount(), 2000)
    this._notifInterval = setInterval(() => this.getUnreadNotificationsCount(), 10000);
  },
  beforeDestroy() {
    clearTimeout(this._notifTimeout)
    clearInterval(this._notifInterval)
  },
  mounted() {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault()
      this.deferredPwaPrompt = e
    })
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
#side-navi {
  #menu_wrapper {
    padding-top: 0;
    background-color: #d1af60 !important;
    overflow-x: hidden;
  }

  .menu_header {
    background-color: #fff !important;
  }

  .menu_btn {
    position: fixed;
    left: 0;
    z-index: 10;
  }

  .notif-btn-wrap {
    position: absolute;
    right: 10px;
    top: 8px;
    z-index: 10
  }

  .btn-notif-bell {
    position: relative;
    color: #d1af60 !important;
    background-color: #fff !important;
    border: 1px solid #d1af60 !important;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);

    &:hover {
      color: #866f3b !important;
      border: 2px solid #d1af60 !important;
    }

    i {
      font-size: 12px;
    }
  }

  .notif-badge {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(40%, -40%);
    background: #e74c3c;
    color: #fff;
    border-radius: 20px;
    font-size: 0.6rem;
    font-weight: 700;
    min-width: 18px;
    height: 18px;
    padding: 0 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    border: 2px solid #fff;
    pointer-events: none;
  }

  .logo_menu {
    max-height: 40px;
  }

  #main_menu {
    color: #fff !important;
    min-height: 100vh;
    min-height: -webkit-fill-available;
    height: 100vh;
  }

  #main_menu a {
    color: #fff !important;
  }

  #main_menu .nav-item {
    padding: 0 !important;
    margin: 0 !important;
  }

  #main_menu .nav-item > .nav-link {
    padding: 0 !important;
  }

  #main_menu .ff > .nav-link > .menu_dd {
    font-size: 1.05rem;
    font-weight: 600;
    padding-top: 3px !important;
    padding-bottom: 3px !important;
    display: block;
    letter-spacing: 0.2px;
  }

  #main_menu .ff > .nav-link > .menu_dd i {
    font-size: 1rem;
    width: 20px;
    text-align: center;
  }

  #menu_footer a {
    color: #d1af60 !important;
  }

  #main_menu .menu_dd_sub {
    padding-left: 2.75rem !important;
  }

  #main_menu .ff--dropdown > .nav-link {
    margin-top: 14px !important;
  }

  #main_menu .menu_dd:hover,
  #main_menu .menu_dd:focus {
    color: #e0af31 !important;
    background-color: #fff !important;
    font-weight: bold !important;
    text-decoration: none !important;
  }

  #main_menu .menu_dd:active {
    color: #fff !important;
    background-color: rgba(0, 0, 0, 0.2) !important;
    font-weight: bold !important;
    text-decoration: none !important;
  }

  /* Touch devices: suppress sticky white hover, use active instead */
  @media (hover: none) {
    #main_menu .menu_dd:hover {
      color: #fff !important;
      background-color: transparent !important;
      font-weight: normal !important;
    }
  }

  #main_menu .ff > .nav-link > .menu_dd {
    transition: background-color 0.25s ease;
  }

  #main_menu .b-sidebar-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100vh;
    overflow-y: auto;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE/Edge */

    &::-webkit-scrollbar {
      display: none; /* Chrome/Safari */
    }
  }

  #menu_footer {
    background: white;
    margin-top: 1rem;
  }

  .modal-xl {
	  width: 1000px;
  }

  .modalBtn {
    margin: 30px;
  }

  // Target Safari browsers only
  @media screen and (-webkit-min-device-pixel-ratio: 0) and (max-width: 600px) {
    #menu_footer.safari_only {
      margin-bottom: 5rem;
      padding-bottom: env(safe-area-inset-bottom);
    }
  }
}
</style>
